export default "__VITE_ASSET__DxlYQ1pa__"